/* ===== LUMA VISION THEME JS v5.0 ===== */
(function () {

  /* ── Money formatting (mirrors Shopify's money_format setting) ── */
  function formatMoney(cents, format) {
    format = format || window.shopMoneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withComma = parts.join('.');
    var noDecimal = parts[0];
    return format
      .replace('{{amount}}', withComma)
      .replace('{{ amount }}', withComma)
      .replace('{{amount_no_decimals}}', noDecimal)
      .replace('{{ amount_no_decimals }}', noDecimal);
  }

  document.addEventListener('DOMContentLoaded', function () {

    /* ── Mobile menu ── */
    var menuBtn = document.querySelector('.mobile-menu-btn');
    var mobileNav = document.querySelector('.mobile-nav');
    var mobileClose = document.querySelector('.mobile-nav-close');
    function closeMobileNav() {
      if (!mobileNav) return;
      mobileNav.classList.remove('open');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (menuBtn && mobileNav) {
      menuBtn.addEventListener('click', function () {
        mobileNav.classList.add('open');
        menuBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });
      if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
      mobileNav.addEventListener('click', function (e) {
        if (e.target === mobileNav) closeMobileNav();
      });
    }

    /* ── FAQ accordion ── */
    document.querySelectorAll('.faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = this.closest('.faq-item');
        if (!item) return;
        var list = item.closest('.faq-list');
        var isOpen = item.classList.contains('open');
        if (list) {
          list.querySelectorAll('.faq-item').forEach(function (el) { el.classList.remove('open'); });
        }
        if (!isOpen) item.classList.add('open');
      });
    });

    /* ── Product gallery thumbs ── */
    document.querySelectorAll('.product-gallery-thumbs img').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mainImg = document.querySelector('.product-gallery-main img');
        if (mainImg) {
          mainImg.src = this.src.replace(/(_)\d+x\d+(_crop_center)?/, '$1800x800$2');
          document.querySelectorAll('.product-gallery-thumbs img').forEach(function (t) { t.classList.remove('active'); });
          this.classList.add('active');
        }
      });
    });

    /* ── Cart count badge ── */
    function updateCartCount(itemCount) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = itemCount;
        el.style.display = itemCount > 0 ? 'flex' : 'none';
      });
    }

    /* ── Cart drawer ── */
    var drawer = document.getElementById('CartDrawer');
    var drawerBody = document.getElementById('CartDrawerBody');
    var drawerFooter = document.getElementById('CartDrawerFooter');
    var drawerSubtotal = document.getElementById('CartDrawerSubtotal');

    function renderDrawer(cart) {
      if (!drawerBody) return;
      updateCartCount(cart.item_count);
      if (!cart.items || cart.items.length === 0) {
        drawerBody.innerHTML = '<div class="cart-drawer-empty">Your cart is empty.</div>';
        if (drawerFooter) drawerFooter.style.display = 'none';
        return;
      }
      var html = '';
      cart.items.forEach(function (item) {
        html += '<div class="cart-drawer-item">' +
          '<img src="' + item.image + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '" width="64" height="64">' +
          '<div><div class="cart-drawer-item-name">' + item.product_title + '</div>' +
          '<div class="cart-drawer-item-meta">Qty ' + item.quantity + '</div></div>' +
          '<div class="cart-drawer-item-price">' + formatMoney(item.line_price) + '</div>' +
          '</div>';
      });
      drawerBody.innerHTML = html;
      if (drawerFooter) drawerFooter.style.display = 'block';
      if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);
    }

    function fetchCart() {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }

    function openDrawer(cart) {
      if (!drawer) return;
      var render = cart ? Promise.resolve(cart) : fetchCart();
      render.then(renderDrawer);
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-locked');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-locked');
    }
    if (drawer) {
      drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });
    }

    var cartIconBtn = document.getElementById('CartIconBtn');
    if (cartIconBtn && drawer) {
      cartIconBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    }

    /* Initial cart count on page load */
    fetchCart().then(function (cart) { updateCartCount(cart.item_count); }).catch(function () {});

    /* ── Shared add-to-cart helper ── */
    function addToCart(variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      });
    }

    /* ── Add to Cart buttons (product page + collection quick-add) — one click, opens cart drawer ── */
    document.querySelectorAll('.product-add-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = this.dataset.variantId;
        if (!variantId) return;
        var self = this;
        var originalText = self.textContent;
        self.textContent = 'Adding…';
        self.classList.add('loading');
        self.disabled = true;

        addToCart(variantId, 1)
          .then(function () {
            return fetchCart();
          })
          .then(function (cart) {
            self.textContent = '✓ Added';
            self.classList.remove('loading');
            self.disabled = false;
            openDrawer(cart);
            setTimeout(function () { self.textContent = originalText; }, 2000);
          })
          .catch(function () {
            self.textContent = 'Error — Try Again';
            self.classList.remove('loading');
            self.disabled = false;
            setTimeout(function () { self.textContent = originalText; }, 2500);
          });
      });
    });

    /* ── Buy Now / instant checkout button on product page ── */
    var checkoutBtn = document.querySelector('.product-checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        var variantId = this.dataset.variantId;
        if (!variantId) { window.location.href = '/cart'; return; }
        var original = this.textContent;
        this.textContent = 'Redirecting…';
        this.disabled = true;
        addToCart(variantId, 1)
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { window.location.href = '/cart'; });
      });
    }

    /* ── Hero / Specs / CTA / sticky-bar "Add to Cart" buttons → one click, opens cart drawer ── */
    document.querySelectorAll('.hero-buy-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = this.dataset.variantId;
        if (!variantId) { window.location.href = '/collections/all'; return; }
        var self = this;
        var original = self.textContent;
        self.textContent = 'Adding…';
        self.disabled = true;
        addToCart(variantId, 1)
          .then(function () { return fetchCart(); })
          .then(function (cart) {
            self.textContent = original;
            self.disabled = false;
            openDrawer(cart);
          })
          .catch(function () {
            self.textContent = original;
            self.disabled = false;
          });
      });
    });

    /* ── Hide mobile CTA bar when user is at top (hero visible) ── */
    var mobileCta = document.querySelector('.mobile-cta-bar');
    if (mobileCta) {
      function onScroll() {
        if (window.scrollY < 300) {
          mobileCta.setAttribute('aria-hidden', 'true');
          mobileCta.style.transform = 'translateY(100%)';
        } else {
          mobileCta.setAttribute('aria-hidden', 'false');
          mobileCta.style.transform = 'translateY(0)';
        }
      }
      mobileCta.style.transition = 'transform 0.3s ease';
      mobileCta.style.transform = 'translateY(100%)';
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* ── Cart page qty +/- : updates the real Shopify cart, then refreshes totals ── */
    document.addEventListener('click', function (e) {
      var isInc = e.target.classList.contains('qty-inc');
      var isDec = e.target.classList.contains('qty-dec');
      if (!isInc && !isDec) return;

      var wrap = e.target.closest('.cart-qty');
      if (!wrap) return;
      var span = wrap.querySelector('span');
      var line = wrap.dataset.line;
      if (!span || !line) return;

      var qty = parseInt(span.textContent, 10) || 1;
      if (isInc) qty = Math.min(qty + 1, 99);
      if (isDec) qty = Math.max(qty - 1, 0);

      wrap.querySelectorAll('button').forEach(function (b) { b.disabled = true; });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          wrap.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
        });
    });

    /* ── Smooth scroll ── */
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          closeMobileNav();
        }
      });
    });

  });
})();
